import moment from 'moment';

import { Session as CurrentSession, SessionDict } from '../../typings/common';
import {
    LocalStorage,
    SessionStorage,
    StorageData,
    StorageKeyType
} from '../Storage/Storage';

// Максимальное количество сессий
const SessionLimit = 10;

// Текущая сессия пользователя. Пишется в два стора
// Первый стор - LocalStorage - предназначен для инициализации вкладки.
// Второй стор - SessionStorage - хранит и отдает сессию текущей вкладки.
// Сессия закрепляется за логином пользователя

export class Session {
    public static setValueToCurrentSession(
        key: string,
        rawValue: CurrentSession
    ): void {
        Session.setLocalSession(key, rawValue);
        Session.setExpireGlobalSession(key, rawValue);
    }

    public static getValueFromCurrentSession(key: string): CurrentSession {
        const valueFromCurrentSession = SessionStorage.getItem(
            StorageKeyType.session
        );

        if (valueFromCurrentSession === undefined) {
            const valueFromLocalSession = LocalStorage.getItem(
                StorageKeyType.session
            );

            return valueFromLocalSession
                ? valueFromLocalSession[key] || {}
                : {};
        } else {
            return valueFromCurrentSession[key] || {};
        }
    }

    public static getValueFromCurrentLocalSession(key: string): CurrentSession {
        const valueFromLocalSession = LocalStorage.getItem(
            StorageKeyType.session
        );

        return valueFromLocalSession ? valueFromLocalSession[key] || {} : {};
    }

    private static expireStorage(
        session: StorageData[StorageKeyType.session]
    ): StorageData[StorageKeyType.session] {
        const currentSessionKeys = Object.keys(session);

        // Производим поиск и удаление самой давней созданной сессии из localStorage или sessionStorage по достижению лимита
        if (currentSessionKeys.length > SessionLimit) {
            // Поиск старого ключа через поиск min
            const maxOldKey = currentSessionKeys.reduce(
                (acc, val): string => {
                    const currentMin = session[acc] && session[acc].order;
                    const nextValue = session[val] && session[val].order;

                    if (currentMin && nextValue && currentMin > nextValue) {
                        return val;
                    }

                    return acc;
                }
            );

            delete session[maxOldKey];
        }

        return session;
    }

    private static setExpireGlobalSession(
        key: string,
        rawValue: CurrentSession
    ): void {
        let globalSession = LocalStorage.getItem(
            StorageKeyType.session
        ) as SessionDict;

        const valuesCurrentSessionForKey = {
            order: Number(moment()),
            ...rawValue
        };

        if (globalSession) {
            const valuesGlobalSessionForKey = globalSession[key] || {};
            globalSession = this.expireStorage(globalSession);

            LocalStorage.setItem(StorageKeyType.session, {
                ...globalSession,
                [key]: {
                    ...valuesGlobalSessionForKey,
                    ...valuesCurrentSessionForKey
                }
            });
        } else {
            LocalStorage.setItem(StorageKeyType.session, {
                [key]: valuesCurrentSessionForKey
            });
        }
    }

    private static setLocalSession(
        key: string,
        rawValue: CurrentSession
    ): void {
        const localSession = SessionStorage.getItem(StorageKeyType.session);
        const localSessionValueByKey =
            (localSession && localSession[key]) || {};
        const currentLocalSession = {
            [key]: {
                // задаем время создания сессии
                order: Number(moment()),
                ...localSessionValueByKey,
                ...rawValue
            }
        };

        if (localSession) {
            // задаем время создания сессии
            SessionStorage.setItem(
                StorageKeyType.session,
                Object.assign(localSession, currentLocalSession)
            );
        } else {
            SessionStorage.setItem(StorageKeyType.session, currentLocalSession);
        }
    }
}
